module.exports = __webpack_public_path__ + "media/components/country-flag/static/kz-6456c2899f54772b62302b6a42e4c7f1.svg";